import { Check } from "lucide-react";
import { AGNOSTIC_STACK } from "@/data/content";
import { SectionHeading } from "@/components/shared/SectionHeading";
import { Reveal, Stagger, Item } from "@/components/shared/Reveal";

export const TechAgnostic = () => (
  <section data-testid="tech-agnostic-section" className="section relative bg-[#F4F6FA] text-navy">
    <div className="wrap grid gap-14 lg:grid-cols-12">
      <div className="lg:col-span-6">
        <SectionHeading
          light
          eyebrow="Technology agnostic"
          title="The right technology for your operation. Not a technology you are forced to use."
        />
        <Reveal delay={0.1} className="mt-8 space-y-5 text-base leading-relaxed text-slate-600 md:text-lg">
          <p>Wexoz is technology-agnostic. We evaluate your operational requirements first, then recommend the combination of hardware, software, connectivity and platforms that best fits your business.</p>
          <p>That includes established fleet, logistics and video platforms from proven technology providers — deployed and integrated where they fit, alongside the devices, sensors and systems your operation already relies on.</p>
        </Reveal>
        <Reveal delay={0.2} className="mt-10 inline-flex items-center gap-4 rounded-2xl border border-slate-200 bg-white px-6 py-5 shadow-sm">
          <span className="h-10 w-1 rounded-full bg-cyan-500" />
          <p className="font-heading text-xl font-semibold text-navy">Your requirement comes first. Technology follows.</p>
        </Reveal>
      </div>

      <div className="lg:col-span-6">
        <Reveal delay={0.15} className="mb-5 font-mono text-[11px] uppercase tracking-[0.22em] text-slate-500">We can deploy and integrate</Reveal>
        <Stagger className="grid gap-3 sm:grid-cols-2" stagger={0.05}>
          {AGNOSTIC_STACK.map((t) => (
            <Item key={t} data-testid={`agnostic-item-${t.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
              className="flex items-center gap-3 rounded-xl border border-slate-200 bg-white px-5 py-4 text-sm font-medium text-navy transition-[border-color,transform,box-shadow] duration-300 hover:-translate-y-0.5 hover:border-cyan-500/60 hover:shadow-[0_20px_40px_-25px_rgba(10,21,38,0.4)]">
              <span className="flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-cyan-500/10 text-cyan-600"><Check className="h-3 w-3" /></span>
              {t}
            </Item>
          ))}
        </Stagger>
      </div>
    </div>
  </section>
);
